import { render, staticRenderFns } from "./StudentsProfile.vue?vue&type=template&id=7cb42750&"
import script from "./StudentsProfile.vue?vue&type=script&lang=js&"
export * from "./StudentsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports